import React from "react";

interface PinIconProps {
  color?: string;
  width?: number;
  height?: number;
  size?: number;
  className?: string;
}

const PinIcon: React.FC<PinIconProps> = ({
  color = "#0A8442",
  width,
  height,
  size = 12,
  className = "",
}) => {
  const finalWidth = width ?? size;
  const finalHeight = height ?? size;

  return (
    <svg
      width={finalWidth}
      height={finalHeight}
      viewBox="0 0 6 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.2207 5.60717L3.22068 7.33787L3.2207 5.60717ZM1.99571 1.27981L4.44559 1.28C4.5471 1.27997 4.647 1.30533 4.73621 1.35376C4.82542 1.40219 4.9011 1.47216 4.95638 1.55729C5.01165 1.64243 5.04476 1.74004 5.0527 1.84124C5.06063 1.94243 5.04314 2.04401 5.00181 2.13672L4.55362 3.1407C4.47583 3.31507 4.44013 3.50528 4.4494 3.69599C4.45867 3.88669 4.51265 4.07254 4.60699 4.23853L4.99682 4.92499C5.03628 4.99446 5.05682 5.07306 5.05639 5.15295C5.05596 5.23284 5.03458 5.31122 4.99438 5.38027C4.95419 5.44931 4.89658 5.5066 4.82731 5.54641C4.75805 5.58623 4.67955 5.60717 4.59966 5.60716L1.84196 5.60698C1.76207 5.60699 1.68357 5.58605 1.6143 5.54624C1.54504 5.50643 1.48743 5.44914 1.44724 5.3801C1.40704 5.31106 1.38566 5.23268 1.38524 5.15278C1.38481 5.07289 1.40535 4.99429 1.44481 4.92482L1.83487 4.23857C1.92915 4.07254 1.98306 3.88667 1.99226 3.69596C2.00147 3.50526 1.96569 3.31507 1.88784 3.14074L1.4399 2.13699C1.39849 2.04429 1.38092 1.9427 1.38879 1.84148C1.39666 1.74026 1.42972 1.64261 1.48496 1.55742C1.5402 1.47223 1.61586 1.40221 1.70506 1.35372C1.79427 1.30524 1.89418 1.27983 1.99571 1.27981Z"
        fill={color}
      />
      <path
        d="M3.2207 5.60717L3.22068 7.33787M1.99571 1.27981L4.44559 1.28C4.54709 1.27997 4.647 1.30533 4.73621 1.35376C4.82542 1.40219 4.9011 1.47216 4.95638 1.55729C5.01165 1.64243 5.04476 1.74004 5.0527 1.84124C5.06063 1.94243 5.04314 2.04401 5.00181 2.13672L4.55362 3.1407C4.47583 3.31507 4.44013 3.50528 4.4494 3.69599C4.45867 3.88669 4.51265 4.07254 4.60699 4.23853L4.99682 4.92499C5.03628 4.99446 5.05682 5.07306 5.05639 5.15295C5.05596 5.23284 5.03458 5.31122 4.99438 5.38027C4.95419 5.44931 4.89658 5.5066 4.82731 5.54641C4.75805 5.58623 4.67955 5.60717 4.59966 5.60716L1.84196 5.60698C1.76207 5.60699 1.68357 5.58605 1.6143 5.54624C1.54504 5.50643 1.48743 5.44914 1.44724 5.3801C1.40704 5.31106 1.38566 5.23268 1.38524 5.15278C1.38481 5.07289 1.40535 4.99429 1.44481 4.92482L1.83487 4.23857C1.92915 4.07254 1.98306 3.88667 1.99226 3.69596C2.00147 3.50526 1.96569 3.31507 1.88784 3.14074L1.4399 2.13699C1.39849 2.04429 1.38092 1.9427 1.38879 1.84148C1.39666 1.74026 1.42972 1.64261 1.48496 1.55742C1.5402 1.47223 1.61586 1.40221 1.70506 1.35372C1.79427 1.30524 1.89418 1.27983 1.99571 1.27981Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PinIcon;
